var udata = udata || [];
e4.ecom.productlist = {
    jProductList: jQuery( '.js-e-productlist' ),
    init: function () {
        if ( e4.ecom.productlist.jProductList.length === 1 ) {
            e4.ecom.productlist.filters.init();
        }
    },
    filters: {
        init: function () {
            e4.ecom.productlist.filters.bindEvents();
            e4.ecom.productlist.filters.collapse.init();
        },
        bindEvents: function () {
            jQuery( '.js-e-productlist-filters-group' ).each( function () {
                jQuery( this ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', false );
                jQuery( '.js-e-productlist-filter', this ).each( function () {
                    if ( jQuery( this ).is( ':checked' ) === false ) {
                        var checkedLength = jQuery( this ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).filter( ':checked' ).length;
                        if ( checkedLength === 0 ) {
                            jQuery( this ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', true );
                        }
                    }
                } );
            } );
            e4.ecom.productlist.jProductList.on( 'change', '.js-e-productlist-filter', function () {
                e4.ecom.productlist.filters.applyFilters( this );
            } );
            e4.ecom.productlist.jProductList.on( 'click', '.js-e-productlist-filters-options-collapse-peek-toggle', function ( event ) {
                event.preventDefault();
                e4.ecom.productlist.filters.collapse.peek.toggle( this );
            } );
            e4.ecom.productlist.jProductList.on( 'click', '.js-e-productlist-filters-remove', function ( event ) {
                event.preventDefault();
                e4.ecom.productlist.filters.removeFilter( this );
            } );
            jQuery( document ).on( 'click', '.js-e-productlist-filters-clear-all', function ( event ) {
                event.preventDefault();
                e4.ecom.productlist.filters.resetAll();
            } );
            e4.ecom.productlist.jProductList.on( 'change', '.js-e-productlist-filters-option-reset-group', function ( event ) {
                event.preventDefault();
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    e4.ecom.productlist.filters.resetGroup( this );
                }
                else {
                    jQuery( this ).prop( 'checked', true );
                }
            } );
            e4.ecom.productlist.setSort();
        },
        applyFilters: function ( domElm ) {
            var jThis = jQuery( domElm );
            jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', false );
            if ( jThis.is( ':checked' ) === false ) {
                var checkedLength = jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).filter( ':checked' ).length;
                if ( checkedLength === 0 ) {
                    jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', true );
                }
            }
            
            var labelValue = jThis.closest('label').attr('title');
            var categoryName =  jThis.closest( '.js-e-productlist-filters-group' ).find('.e-productlist-filters-group-header').find('.e-productlist-filters-group-name').text();
                       
            var filterData = [{
                'category': categoryName,
                'name': labelValue
            }];
            
            e4.ecom.productlist.filters.track( labelValue, categoryName);
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        removeFilter: function ( domElm ) {
            var strValue = jQuery( domElm ).data( 'value' ),
                strSystemName = jQuery( domElm ).data( 'system-name' );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-filter[name="' + strSystemName + '"].js-e-productlist-filter[value="' + strValue + '"]' ).prop( 'checked', false );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        resetGroup: function ( domElm ) {
            jQuery( domElm ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        resetAll: function () {
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        track: function (label, categoryName){
            window.udata = window.udata || [];
            udata.push({
                event_name: 'list filter',
                list_name: 'products',
                list_filters: [{
                    category: categoryName,
                    name: label
                }]
            });
            console.log(window.udata);
        },
        collapse: {
            init: function () {
                jQuery( '.js-e-productlist-filters-group-options' ).each( function () {
                    var jThis = jQuery( this ),
                        jPeekable = jThis.find( '.js-e-productlist-filters-options-collapse-peek' );
                    if ( jThis.is( '.collapse' ) === true ) {
                        jThis.addClass( 'show' );
                    }
                    if ( jPeekable.length === 1 ) {
                        e4.ecom.productlist.filters.collapse.peek.setHeight( jPeekable );
                    }
                    if ( jThis.is( '.is-expanded' ) === false ) {
                        jThis.removeClass( 'show' );
                    }
                } );
            },
            peek: {
                setHeight: function ( jPeekable ) {
                    var jFilterOptions = jPeekable.find( '.js-e-productlist-filters-option' ),
                        intPeekOptionCount = parseInt( jQuery( '.js-e-visible-options-count' ).val() ) + 1.5,
                        intHeightPeek = Math.ceil( jFilterOptions.first().outerHeight() ) * intPeekOptionCount,
                        intHeightInitial = jPeekable.get( 0 ).scrollHeight,
                        intHeightToggleButton = jPeekable.find( '.js-e-productlist-filters-options-collapse-peek-toggle' ).outerHeight();

                    if ( jFilterOptions.filter( '.is-selected' ).length === 0 && jFilterOptions.length > intPeekOptionCount && intHeightInitial > intHeightPeek * e4.settings.collapse.peekSizeMin ) {
                        jPeekable.data( {
                            'height-peek': intHeightPeek + intHeightToggleButton,
                            'height-initial': intHeightInitial + intHeightToggleButton,
                        } );
                        jPeekable.addClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-peek' ) );
                    }
                    else {
                        jPeekable.removeClass( 'e-productlist-filters-options-collapse-peek is-peeking' );
                        jPeekable.find( '.js-e-productlist-filters-options-collapse-peek-toggle' ).remove();
                    }
                },
                toggle: function ( domElm ) {
                    var jPeekable = jQuery( domElm ).closest( '.js-e-productlist-filters-options-collapse-peek' );
                    if ( jPeekable.is( '.is-peeking' ) === true ) {
                        jPeekable.removeClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-initial' ) );
                    }
                    else {
                        jPeekable.addClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-peek' ) );
                    }
                }
            }
        }
    },
    setSort: function () {
        jQuery( '.sortProducts' ).on( 'change', function () {
            jQuery( 'input[name="SortOrder"]' ).val( jQuery( this ).val() );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        } );
    },
    setScrollTop: function ( intScrollTop ) {
        var jWindow = jQuery( window );
        if ( intScrollTop < jWindow.scrollTop() ) {
            intScrollTop -= jWindow.height() / 100 * e4.settings.scrollToAnchor.nudge;
            e4.scrollToAnchor.animate( intScrollTop, e4.nav.global.hide );
        }
    }
};
